module.exports = __webpack_public_path__ + "img/ewm-android.3fc0ddcc.png";